import { cn } from '../../../shared/lib/cn';

const TONE = {
  danger: 'bg-danger text-surface',
  motion: 'bg-motion text-surface',
  quiet: 'bg-muted text-surface',
} as const;

// The number itself, not a dot: "is it one or forty" is the question the rail is glanced for.
// Collapsed it rides the icon's corner; expanded it sits at the end of the label's row.
export const RailBadge = ({
  count,
  tone,
  collapsed,
}: {
  count: number;
  tone: keyof typeof TONE;
  collapsed: boolean;
}) => (
  <span
    aria-hidden
    className={cn(
      'flex h-rail-badge min-w-rail-badge items-center justify-center rounded-full px-tight font-mono text-info font-semibold',
      collapsed ? 'absolute top-hair left-6 border-2 border-surface-sunken' : 'ml-auto',
      TONE[tone],
    )}
  >
    {count > 99 ? '99+' : count}
  </span>
);
